import { Button, Form, Input, Table, notification } from 'antd';
import React, { useState } from 'react';
import { showErrorNotification, showInfoNotification } from '../../../Services/Notifications';
import { CreateColumns, headers } from '../../../Utils/utils';
import '.././CompressImage.scss';
notification.config({ maxCount: 1 });
const columns = CreateColumns(['Name', 'Time(sec)', 'Reduced(Times)', 'Description', 'Status']);
const CompressImageForm = () => {
  const [file, setFile] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [quality, setQuality] = useState('medium');

  const handleFileChange = (event) => {
    let selectedFile = event.target.files;
    setTableData(() => []);
    console.log('selectedFile', selectedFile, Object.keys(selectedFile));
    let noImgMsg;
    let msg = 'Only upload image and pdf.';
    if (selectedFile && Object.keys(selectedFile).length) {
      let notImage = Object.keys(selectedFile).find(
        (item) => !selectedFile[item].type.includes('image') && !selectedFile[item].type.includes('pdf'),
      );
      // console.log("notImage", notImage);
      if (typeof notImage !== 'undefined') noImgMsg = msg;
    } else noImgMsg = msg;
    if (noImgMsg) {
      setDisabled(true);
      showInfoNotification(noImgMsg);
      setFile(null);
    } else {
      setDisabled(false);
      setFile(selectedFile);
    }
    console.log('Called');
  };

  const callBlobDownload = (file, key) => {
    let name = file.name.split('.')[0];
    let size = file.size;
    let t1 = Date.now();
    console.log('File', file);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('quality', quality);
    // console.log("Time", Date.now())

    // Object.values(file).map((item) => formData.append("file", item));
    // formData.append("file", file);
    // Send the file to the server for compression (using fetch or Axios)
    let msg = '';
    let sizeinkb = file?.size / 1024;
    let rowData = {
      Name: file.name + '-' + sizeinkb.toFixed(2) + 'kb',
      'Time(sec)': '--',
      'Reduced(Times)': '--',
      Description: 'Please check image',
      Status: 'Failed',
      key: name + key,
    };
    let url = process.env.REACT_APP_BACKEND_HOST + 'services/compressor';
    if (file.type === 'application/pdf') {
      url += '/pdf';
    }
    let dataHeaders = headers();
    delete dataHeaders['Content-Type'];
    fetch(url, {
      method: 'POST',
      body: formData,
      headers: dataHeaders
    })
      .then((response) => response.blob())
      .then((compressedBlob) => {
        console.log('compressedBlob', compressedBlob);
        if (!compressedBlob.type.includes('image') && !compressedBlob.type.includes('pdf')) {
          msg = 'Uploaded images and pdf size should be less than 200kb or check format.';
          console.log(msg);
          rowData.Description = msg;
          // showInfoNotification(msg);
          setTableData((tempTableData) => tempTableData.concat(rowData));
          setLoader(false);
        } else {
          let t2 = Date.now();
          // console.log("t2", t2);
          let reducesSize = compressedBlob.size;
          rowData['Reduced(Times)'] = (size / reducesSize).toFixed(2);
          rowData['Time(sec)'] = ((t2 - t1) / 1000).toFixed(2);
          // rowData.Description = "";
          rowData.Status = 'Success';
          msg = 'Image size reduced by ' + (size / reducesSize).toFixed(2) + ' Times';
          msg += '\n\nTime - ' + ((t2 - t1) / 1000).toFixed(2) + ' sec';
          // console.log(msg);
          // showSuccessNotification(msg);
          // Create a URL for the compressed file
          const compressedURL = URL.createObjectURL(compressedBlob);
          // console.log(compressedURL);
          // Provide a link to download the compressed file
          const downloadLink = document.createElement('a');
          downloadLink.href = compressedURL;
          downloadLink.download = name + '_com.jpeg'; // Replace with the desired file name
          if (file.type === 'application/pdf') {
            downloadLink.download = name + '_com.pdf';
          }
          downloadLink.click();
          rowData.Description = name + '_com.jpeg - ' + (reducesSize / 1024).toFixed(2) + 'kb';
          rowData.key = file.name + key;
          setTableData((tempTableData) => tempTableData.concat(rowData));
          setLoader(false);
        }
      })
      .catch(() => {
        msg = 'Error during file upload';
        rowData.Description = msg;
        setTableData((tempTableData) => tempTableData.concat(rowData));
        setLoader(false);
        // showErrorNotification(msg);
        // console.error("Error during file upload:", error);
      });
  };

  const uploadData = (filesData) => {
    let t1 = Date.now();
    let size = 0;
    setDisabled(true);
    //console.log(filesData);
    const formData = new FormData();
    Object.values(filesData).map((file, key) => {
      size += file.size;
      formData.append('file' + key, file);
    });
    formData.append('quality', quality);

    let obj = {};
    let dataHeaders = headers();
    delete dataHeaders['Content-Type'];
    let otherData = { ...dataHeaders };
    let rowData = {
      Name: 'Files',
      Description: 'Please check image',
      Status: 'Failed',
      key: 'file',
    };

    // console.log("otherData", otherData);
    fetch(process.env.REACT_APP_BACKEND_HOST + 'services/compressor/multiple', {
      method: 'POST',
      body: formData,
      headers: otherData,
    })
      .then((response) => response.blob())
      .then((compressedBlob) => {
        console.log(compressedBlob, 'jsonData'); // Handle the blob data here
        let t2 = Date.now();
        // console.log("t2", t2);
        let reducesSize = compressedBlob.size;
        console.log(reducesSize, size);
        rowData['Reduced(Times)'] = (size / reducesSize).toFixed(2);
        rowData['Time(sec)'] = ((t2 - t1) / 1000).toFixed(2);
        // rowData.Description = "";
        rowData.Status = 'Success';
        let msg = 'Image size reduced by 0 Times';
        const compressedURL = URL.createObjectURL(compressedBlob);
        // console.log(compressedURL);
        // Provide a link to download the compressed file
        const downloadLink = document.createElement('a');
        downloadLink.href = compressedURL;
        downloadLink.download = 'compressed_file-' + t1 + '.pdf'; // Replace with the desired file name
        downloadLink.click();
        rowData.Description = 'compressed_file.pdf - ' + (reducesSize / 1024).toFixed(2) + 'kb';
        console.log(rowData);
        setTableData((tempTableData) => tempTableData.concat(rowData));
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
        setDisabled(false);
        showErrorNotification(error.message);
        // throw new Error("Network response was not ok.");
        // console.error("Fetch error:", error);
      });
  };

  const handleFileUpload = (event) => {
    console.log(event.target.value, '.....');
    const isMerge = event.currentTarget.getAttribute('data-is_merge') === 'true';
    setLoader(true);
    setTableData(() => []);
    if (file) {
      showInfoNotification('Task is processing...');
      if (isMerge) {
        uploadData(file);
      } else {
        Object.values(file).map((item, key) => callBlobDownload(item, key, isMerge));
      }
    } else {
      if (!file) showInfoNotification('No file Found');
      else showInfoNotification('No image found');
    }
  };

  return (
    <div className="container">
      <div className="my_form_div row">
        <div className="col-md-12">
          <Form className="my_form">
            <Input
              id="myFile"
              type="file"
              className="uploaddoccs"
              onChange={handleFileChange}
              multiple
              placeholder="upload multiple images"
            />
            <label className="text-bold-q">Quality: </label>
            <div className="form-check form-check-inline">
              <label>
                <input
                  type="radio"
                  checked={quality === 'low'}
                  name="quality"
                  value={'low'}
                  className="form-check-input"
                  onChange={() => setQuality('low')}
                />
                Low
              </label>
            </div>
            <div className="form-check form-check-inline">
              <label>
                <input
                  type="radio"
                  checked={quality === 'medium'}
                  name="quality"
                  value={'medium'}
                  className="form-check-input"
                  onChange={() => setQuality('medium')}
                />
                Medium
              </label>
            </div>
            <div className="form-check form-check-inline">
              <label>
                <input
                  type="radio"
                  checked={quality === 'high'}
                  name="quality"
                  value={'high'}
                  className="form-check-input"
                  onChange={() => setQuality('high')}
                />
                High
              </label>
            </div>
            <Button className="btn btn-primary" data-is_merge={false} onClick={handleFileUpload} disabled={disabled}>
              Compress and Download
            </Button>
            <Button className="btn btn-primary" data-is_merge={true} onClick={handleFileUpload} disabled={disabled}>
              Compress & Merge In Pdf
            </Button>
          </Form>
        </div>
      </div>
      {loader && (
        <img
          src="https://remitxb2c.s3.ap-south-1.amazonaws.com/1691587401180-loader.gif"
          alt="loader"
          width={'98px'}
          className="my_loader"
        />
      )}
      {!!tableData.length && <Table className="table my_table mrg-t30" columns={columns} dataSource={tableData} />}
    </div>
  );
};

export default CompressImageForm;
